import React, { Children } from 'react';
import PropTypes from 'prop-types';
import chunk from 'lodash/chunk';

import Carousel, { Slide } from '@redbubble/design-system/react/Carousel';
import Box from '@redbubble/design-system/react/Box';

const StackedCarousel = ({ rows, children, slideWidth, ...rest }) => {
  return (
    <Carousel {...rest}>
      {chunk(Children.toArray(children), rows).map(column => (
        <Slide
          style={{ width: slideWidth }}
          key={column.map(({ props }) => props.id).join('-')}
        >
          {column.map((child, itemIndex) => (
            <Box
              key={child.props.id}
              marginBottom={(itemIndex + 1) % rows === 0 ? 0 : 1}
            >
              {child}
            </Box>
          ))}
        </Slide>
      ))}
    </Carousel>
  );
};

StackedCarousel.propTypes = {
  rows: PropTypes.number,
  children: PropTypes.node,
  slideWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

StackedCarousel.defaultProps = {
  rows: 1,
  children: null,
  slideWidth: '220'
};

export default StackedCarousel;
